var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPriorityMark = function SvgPriorityMark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.699951 7.79999V1.39999H2.29995V7.79999H0.699951ZM2.29995 11V12.616H0.699951V11H2.29995Z",
    fill: "#E14E2E",
    stroke: "#E14E2E",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPriorityMark);
export { ForwardRef as ReactComponent };